

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Periode from '@/components/MainSection/Periode.vue';
import { eventBus } from '@/constants/bus';

@Component({
	components: {
		Periode
	}
})
export default class GrandePeriode extends Vue {
	@Prop({ required: true })
	grandeperiode!: any;

	@Prop({ required: true })
	isactive!: boolean;

	@Prop()
	index!: number;

	$refs!: {
		periodeWrapper: HTMLElement;
		compGrandePeriode: HTMLElement;
		periodes: Array<HTMLElement>;
	};

	public transitionOk = false;
	public scrollPosition: number = 0;
	public mousedown: boolean = false;
	private blockMove: boolean = false;

	// Touch event variable
	private dir!: string;
	private swipeType!: string;
	private startX!: number;
	private startY!: number;
	private distX!: number;
	private distY!: number;
	private threshold: number = 150; //required min distance traveled to be considered swipe
	private restraint: number = 100; // maximum distance allowed at the same time in perpendicular direction
	private allowedTime = 500; // maximum time allowed to travel that distance
	private elapsedTime!: number;
	private startTime: any;
	private lastDistance: number = 0;

	get imgUrl() {
		return require('@/assets/img/' + this.grandeperiode.icon + '.svg');
	}

	get isActiveGrandePeriode(): any {
		return this.index == this.$store.getters['getActiveGrandePeriodeIndex'];
	}

	get ActivePeriodeIndex(): any {
		return this.$store.getters['getActivePeriodeIndex'];
	}

	public onMouseDown() {
		//console.log('mouseDown');
		this.mousedown = true;
		this.transitionOk = false;
	}

	public onMouseUp() {
		//console.log('mouseUp');
		this.mousedown = false;
		this.transitionOk = true;
	}

	public onMouseMove(event: any) {
		if (this.mousedown) {
			//console.log('onMouseMove');
			event.preventDefault();
			this.onMoveHorizontal(-event.movementX);
		}
	}

	public onWheel(event: any) {
		if (!this.$store.getters.getHasOpenedPopup) {
			//console.log('onMouseWheel');
			let delta = Math.sign(event.deltaY) * 40;
			this.onMoveHorizontal(delta);
		}
	}

	// TODO un listener on resize, orientation change pour remettre le wheel à 0

	public onMoveHorizontal(delta: number) {
		if (
			this.$store.getters.getIsMobile ||
			typeof this.$refs.periodeWrapper === 'undefined' ||
			typeof this.$refs.compGrandePeriode === 'undefined' ||
			this.blockMove
		) {
			return;
		}

		//console.log('onMoveHorizontal');

		let placeRestante: boolean = this.placeRestante(delta);
		if (this.scrollPosition - delta <= 0 && placeRestante) {

			eventBus.$emit('xScrollStart', false);
			eventBus.$emit('xScrollEnd', false);

			this.scrollPosition = this.scrollPosition - delta;

			let leftBound: number = 0;

			for (let i: number = 0; i < this.$refs.periodes.length; i++) {
				let rightBound: number =
					leftBound +
					this.$refs.periodes[i].getBoundingClientRect().width;
				if (this.ActivePeriodeIndex !== i) {
					if (
						-this.scrollPosition >= leftBound &&
						-this.scrollPosition < rightBound
					) {
						this.$store.commit('setActivePeriodeIndex', i);
						break;
					}
				}

				leftBound += this.$refs.periodes[i].getBoundingClientRect()
					.width;
			}
		} else if (this.scrollPosition - delta > 0) {
			// on arrive au bout à gauche
			eventBus.$emit('xScrollStart', true);
			this.setBlockMove();
			this.setPreviousActiveGrandePeriode();
		} else if (!placeRestante) {
			// on arrive au bout à droite
			eventBus.$emit('xScrollEnd', true);
			this.setBlockMove();
			this.setNextActiveGrandePeriode();
		}
	}

	private setBlockMove() {
		this.blockMove = true;
		let _self = this;
		window.setTimeout(function() {
			_self.blockMove = false;
		}, 1000);
	}

	private placeRestante(delta: number): boolean {
		let totalClientWidth = this.$refs.periodeWrapper.scrollWidth;
		let dispoClientWidth = this.$refs.compGrandePeriode.clientWidth;
		return (
			dispoClientWidth - this.scrollPosition + delta <
			totalClientWidth + 340
		);
	}

	public onTouchStart(e: any): void {
		if (!this.$store.getters.getIsMobile) {
			//console.log('onToucheStart');
			let touchobj = e.changedTouches[0];
			let dir = 'none';
			this.swipeType = 'none';
			this.lastDistance = 0;
			this.startX = touchobj.pageX;
			this.startY = touchobj.pageY;
			this.startTime = new Date().getTime(); // record time when finger first makes contact with surface
			e.preventDefault();
		}
	}

	public onTouchMove(e: any): void {
		if (!this.$store.getters.getIsMobile) {
			//console.log('onToucheMove');
			let touchobj = e.changedTouches[0];
			this.distX = touchobj.pageX - this.startX; // get horizontal dist traveled by finger while in contact with surface
			this.distY = touchobj.pageY - this.startY; // get vertical dist traveled by finger while in contact with surface

			if (Math.abs(this.distX) > Math.abs(this.distY)) {
				// if distance traveled horizontally is greater than vertically, consider this a horizontal movement
				this.dir = this.distX < 0 ? 'left' : 'right';
				this.handleTouch(
					e,
					this.dir,
					'move',
					this.swipeType,
					this.distX
				); // fire callback function with params dir="left|right", phase="move", swipetype="none" etc
			} else {
				// else consider this a vertical movement
				this.dir = this.distY < 0 ? 'up' : 'down';
				this.handleTouch(
					e,
					this.dir,
					'move',
					this.swipeType,
					this.distY
				); // fire callback function with params dir="up|down", phase="move", swipetype="none" etc
			}
			e.preventDefault(); // prevent scrolling when inside DIV
		}
	}

	public onTouchEnd(e: any): void {
		if (!this.$store.getters.getIsMobile) {
			//console.log('onToucheEnd');
			let touchobj = e.changedTouches[0];
			this.elapsedTime = new Date().getTime() - this.startTime; // get time elapsed
			if (this.elapsedTime <= this.allowedTime) {
				// first condition for awipe met
				if (
					Math.abs(this.distX) >= this.threshold &&
					Math.abs(this.distY) <= this.restraint
				) {
					// 2nd condition for horizontal swipe met
					this.swipeType = this.dir; // set swipeType to either "left" or "right"
				} else if (
					Math.abs(this.distY) >= this.threshold &&
					Math.abs(this.distX) <= this.restraint
				) {
					// 2nd condition for vertical swipe met
					this.swipeType = this.dir; // set swipeType to either "top" or "down"
				}

				this.handleTouchSwipe(
					e,
					this.dir,
					'move',
					this.swipeType,
					this.distY
				);
			}
			e.preventDefault();

			this.transitionOk = true;
		}
	}

	private handleTouchSwipe(
		evt: any,
		dir: string,
		phase: string,
		swipetype: string,
		distance: number
	): void {
		if (dir === 'right' || dir === 'left') {
			if (dir === 'left') {
				//console.log('TouchSwipeLeft');
				this.nextPeriode();
			} else {
				this.previousPeriode();
				//console.log('TouchSwipeRight');
			}
		} else if (dir === 'up' || dir === 'down') {
			if (distance > 0) {
				this.setPreviousActiveGrandePeriode();
				//console.log('TouchSwipeUp');
			} else if (distance < 0) {
				this.setNextActiveGrandePeriode();
				//console.log('TouchSwipeDown');
			}
		}
	}

	private handleTouch(
		evt: any,
		dir: string,
		phase: string,
		swipetype: string,
		distance: number
	): void {
		if (dir === 'right' || dir === 'left') {
			let diff: number = this.lastDistance - distance;
			this.lastDistance = distance;
			this.transitionOk = false;
			this.onMoveHorizontal(diff);
			//console.log('handleTouchLeftRight');
		}
	}

	private nextPeriode(): void {
		if (this.ActivePeriodeIndex + 1 === this.$refs.periodes.length) {
			this.setNextActiveGrandePeriode();
		} else {
			this.onActivePeriodeChange(this.ActivePeriodeIndex + 1);
			this.$store.commit(
				'setActivePeriodeIndex',
				this.ActivePeriodeIndex + 1
			);
		}
	}

	private previousPeriode(): void {
		if (this.ActivePeriodeIndex === 0) {
			this.setPreviousActiveGrandePeriode();
		} else {
			this.onActivePeriodeChange(this.ActivePeriodeIndex - 1);
			this.$store.commit(
				'setActivePeriodeIndex',
				this.ActivePeriodeIndex - 1
			);
		}
	}

	private setPreviousActiveGrandePeriode(): void {
		this.mousedown = false;
		this.$store.commit('setPreviousActiveGrandePeriode');
	}
	private setNextActiveGrandePeriode(): void {
		this.mousedown = false;
		this.$store.commit('setNextActiveGrandePeriode');
	}

	private onActivePeriodeChange(index: number) {
		let from = this.$refs.periodes[0].getBoundingClientRect() as DOMRect;
		let to = this.$refs.periodes[index].getBoundingClientRect() as DOMRect;
		this.setScrollPosition(-Math.abs(to.x - from.x));
	}

	private setScrollPosition(position: number) {
		if (this.$store.getters.getIsMobile) {
			this.scrollPosition = 0;
		}
		this.scrollPosition = position;
	}

	private onFlecheMouseDown(direction: string): void {
		if (direction === 'left') {
			this.onMoveHorizontal(-40);
			//console.log('flecheMouseDownLeft');
		} else {
			this.onMoveHorizontal(40);
			//console.log('flecheMouseDownRight');
		}
	}

	protected created(): void {
		this.$nextTick(() => {
			eventBus.$on(this.index + 'periodeChange', (index: number) => {
				this.onActivePeriodeChange(index);
			});
		});

		eventBus.$on(this.index + 'flecheMouseDown', (direction: string) => {
			this.onFlecheMouseDown(direction);
		});
	}

	protected beforeDestroy(): void {
		eventBus.$off(this.index + 'periodeChange');
	}

	@Watch('isactive')
	onShowChange(): void {
		if (!this.isactive) {
			setTimeout(() => {
				this.scrollPosition = 0;
			}, 200);
		}
	}
}
